/* 
Renders the mining page, which contains pool facts and transcoder information
Displays TranscoderTable and TranscoderView differently based on window dimensions
Also manages passing the selected Transcoder between the transcoder table and search box
*/
import { Stack } from "@mantine/core";
import ViewSwitcher from "./ViewSwitcher";
import FactsList from "../components/PoolFacts/PoolFacts";
import { IconBusinessplan, IconCash, IconTools } from "@tabler/icons";
import Cookies from "js-cookie";
import { useState } from "react";
import TranscoderTable from "../components/TranscoderTable/TranscoderTable";
import TranscoderView from "../components/TranscoderView/TranscoderView";

export default function TranscoderPage(props) {
  const [selectedAddress, setAddress] = useState(
    Cookies.get("selectedTranscoder") || ""
  );
  const selectTranscoder = (addr) => {
    if (addr != selectedAddress) {
      Cookies.set("selectedTranscoder", addr);
      setAddress(addr);
    }
  };
  return (
    <Stack spacing={"28px"} sx={{ marginLeft: "28px", marginRight: "28px" }}>
      <FactsList
        objects={[
          {
            title: "Commission",
            logo: <IconBusinessplan size={32} color={"#86c232"} />,
            content: parseFloat(props.poolStatus?.poolCommission) * 100 + "%",
            description:
              "The percentage of fees kept to fund the pool. The remainder is distributed to our Transcoders by ratio of video pixels mined",
          },
          {
            title: "Sessions",
            logo: <IconTools size={32} color={"#86c232"} />,
            content: parseFloat(props.poolInfo.sessionSum) + " Sessions",
            description:
              "Total amount of transcoding sessions active on the pool across all regions",
          },
          {
            title: "Payouts",
            logo: <IconCash size={32} color={"#86c232"} />,
            content: parseFloat(props.poolStatus?.totalPaid).toFixed(4) + " Eth",
            description: "Total amount of Eth rewards payed out to Transcoders",
          },
          {
            title: "Threshold",
            logo: <IconCash size={32} color={"#86c232"} />,
            content: parseFloat(props.poolStatus?.payoutThreshold).toFixed(4) + " Eth",
            description:
              "Once a Transcoder has vested this amount of Eth, they will receive a payout",
          },
        ]}
      />
      <ViewSwitcher
        components={[
          <TranscoderTable
            transcoderInfo={props.transcoderInfo}
            selectTranscoder={selectTranscoder}
            selectedAddress={selectedAddress}
            cachedENS={props.cachedENS}
            poolInfo={props.poolInfo}
          />,
          <TranscoderView
            transcoderInfo={props.transcoderInfo}
            selectTranscoder={selectTranscoder}
            selectedAddress={selectedAddress}
            paymentInfo={props.paymentInfo}
            poolInfo={props.poolInfo}
          />,
        ]}
      />
    </Stack>
  );
}
